import { render } from "./VerifyOTP.vue?vue&type=template&id=3cc2b2e2&scoped=true"
import script from "./VerifyOTP.vue?vue&type=script&lang=js"
export * from "./VerifyOTP.vue?vue&type=script&lang=js"

import "./VerifyOTP.vue?vue&type=style&index=0&id=3cc2b2e2&scoped=true&lang=css"

import exportComponent from "D:\\Shivani\\myProjects\\p2p_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cc2b2e2"]])

export default __exports__